// extracted by mini-css-extract-plugin
module.exports = {"UpgradePlan":"UpgradePlan_UpgradePlan__sWIpH"};